import { ProductColor } from '../../../types/graphql/product'
import { EmbroideryColor, EmbroideryFont } from '../useEmbroideryDesigns'

import type { EmbroiderySettingsDefaultTextEmbroideryFont as B2bEmbroiderySettingsDefaultTextEmbroideryFont } from '../../../__generated__/graphql/catalog/graphql'

export enum GenericTextEmbroideryThreadColorEnum {
  Black = 'Black',
  White = 'White',
}

export const GENERIC_TEXT_EMBROIDERY_THREAD_COLOR_NAMES = [
  GenericTextEmbroideryThreadColorEnum.Black,
  GenericTextEmbroideryThreadColorEnum.White,
] as const

export type GenericTextEmbroideryColorKey =
  (typeof GENERIC_TEXT_EMBROIDERY_THREAD_COLOR_NAMES)[number]

export const isGenericTextEmbroideryColorKey = (
  value: unknown
): value is GenericTextEmbroideryColorKey => {
  return GENERIC_TEXT_EMBROIDERY_THREAD_COLOR_NAMES.includes(value as GenericTextEmbroideryColorKey)
}

/**
 * @deprecated leverage useEmbroideryDesigns to get merchandized colors
 */
export const genericTextEmbroideryThreadProductColors = {
  Black: {
    hexCodes: ['000'],
    availability: '',
    name: 'Black',
    rawName: 'Black',
  },
  White: {
    hexCodes: ['fff'],
    availability: '',
    name: 'White',
    rawName: 'White',
  },
} as const satisfies Record<GenericTextEmbroideryColorKey, ProductColor>

/**
 * @deprecated leverage useEmbroideryDesigns to get merchandized colors
 */
export const genericTextEmbroideryThreadProductColorsArray =
  GENERIC_TEXT_EMBROIDERY_THREAD_COLOR_NAMES.map(
    name => genericTextEmbroideryThreadProductColors[name]
  )

// Values used for defaults.
export const genericTextEmbroideryThreadColors = {
  Black: {
    id: 'Black',
    key: 'Black',
    displayName: 'Black',
    hexCode: '#000000',
    designFile: 'Black',
  },
  White: {
    id: 'White',
    key: 'White',
    displayName: 'White',
    hexCode: '#FFFFFF',
    designFile: 'White',
  },
} as const satisfies Record<GenericTextEmbroideryColorKey, EmbroideryColor>

// Values used for defaults.
export const genericTextEmbroideryFonts = {
  Block: {
    id: 'Block',
    key: 'Block',
    scale: 1,
    displayName: 'Block',
    designFile: 'Helvetica',
  },
  Script: {
    id: 'Script',
    key: 'Script',
    scale: 1.2883,
    displayName: 'Script',
    designFile: 'VarsityScriptJF',
  },
} as const satisfies Record<B2bEmbroiderySettingsDefaultTextEmbroideryFont, EmbroideryFont>

export type GenericTextEmbroideryFontKey = keyof typeof genericTextEmbroideryFonts

export const isGenericTextEmbroideryFontKey = (
  value: unknown
): value is GenericTextEmbroideryFontKey => {
  return Object.keys(genericTextEmbroideryFonts).includes(value as GenericTextEmbroideryFontKey)
}
